import React from 'react';
import { Box, Container, Divider, Grid, Typography } from '@mui/material';
import SupportCard from './supportCard';
import { getDictionary, getField } from '@/app/utils/translation/translation';


const Support = ({ isMobile, language, translations }: { isMobile: boolean, language: any, translations: any, }) => {
  const dictionary = getDictionary(translations, 'support', language);
  const isArabic = language === 'arabic';
  return (
    <>

      <Container
        sx={{
          transform: isMobile ? "" : "translateY(-5rem)",
          padding: isMobile ? "0 1rem" : "0",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: isMobile ? "0.5rem" : "1rem",
            marginTop: isMobile ? "4rem" : "0",
          }}
        >


          {isArabic ? (
            <>
              <div>
                <Typography style={{ width: "150px" }} lineHeight={isMobile ? '1.5rem' : ''} fontFamily={"century Gothic"} variant={isMobile ? 'h6' : 'h5'} color={'#4A4848'} fontWeight={'bold'} textAlign={"center"} letterSpacing={isArabic ? "0rem" : "0.2rem"}>
                  <span style={{ fontWeight: "bold", color: "var(--accent-primary)", fontSize: isMobile ? '1.5rem ' : "4rem" }}>24/7</span>
                  <br />
                  <span style={{ color: "var(--text-primary)" }}>{getField(dictionary, 'high-end-reliable', language)}</span>
                </Typography>
              </div>
              <Typography fontFamily={'Roboto'} variant={isMobile ? 'h5' : 'h3'} color={'#4A4848'} fontWeight={'bolder'} lineHeight={isMobile ? '1.5rem' : ''}>
                <span style={{ marginLeft: isArabic ? "0px" : "70px", fontSize: isMobile ? '2rem ' : "4rem" }}>{getField(dictionary, 'support', language)}</span>
                <br />
                <span style={{ color: "var(--text-primary)", fontSize: isMobile ? '2rem ' : "4rem" }}> {getField(dictionary, 'free', language)}</span>
              </Typography>
              <img
                loading="lazy"
                src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/supp.svg`}
                alt="Support"
                style={{
                  width: isMobile ? "30%" : "10%",
                  height: "auto",

                }}
              />
            </>
          ) : (
            <>
              <div>
                <Typography style={{ width: "150px" }} lineHeight={isMobile ? '1.5rem' : '1.7rem'} fontFamily={"century Gothic"} variant={isMobile ? 'h6' : 'h5'} color={'#4A4848'} fontWeight={'bold'} textAlign={"center"} letterSpacing={isArabic ? "0rem" : "0.2rem"}>
                  <span style={{ fontWeight: "bold", color: "var(--accent-primary)", fontSize: isMobile ? '1.5rem ' : "4rem" }}>24/7</span>
                  <br />
                  <span style={{ color: "var(--text-primary)" }}>{getField(dictionary, 'high-end-reliable', language)}</span>
                </Typography>
              </div>
              <Typography fontFamily={'Roboto'} variant={isMobile ? 'h5' : 'h3'} color={'#4A4848'} fontWeight={'bolder'} lineHeight={isMobile ? '1.5rem' : '2.5rem'}>
                <span style={{ marginLeft: isArabic ? "0px" : isMobile ? '30px' : "70px", fontSize: isMobile ? '2rem ' : "4rem", color: "var(--text-primary)" }}>{getField(dictionary, 'free', language)}</span>
                <br />
                <span style={{ color: "var(--text-primary)", fontSize: isMobile ? ' ' : "4rem" }}>{getField(dictionary, 'support', language)} <span style={{ color: "var(--accent-primary)" }}>!</span></span>
              </Typography>
              <img
                src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/supp.svg`}
                loading="lazy"
                alt="Support"
                style={{
                  width: isMobile ? "30%" : "10%",
                  height: "14%",

                }}
              />
            </>
          )}
        </Box >
        <div style={{ justifyContent: "center", display: "flex" }}>   <Divider sx={{ borderColor: 'gray', width: "50%" }} /></div>
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: "2rem" }}>
          <Grid container spacing={4} sx={{ justifyContent: 'center' }}>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              sx={{ display: 'flex', justifyContent: 'center', padding: 0 }}
            >
              <SupportCard
                title={getField(dictionary, 'high-end-support', language)}
                image={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/Active Support-amico.svg`}
                description={getField(dictionary, 'card-one', language)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              sx={{ display: 'flex', justifyContent: 'center', padding: 0 }}
            >
              <SupportCard
                title={getField(dictionary, 'reliable-support', language)}
                image={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/Business support-amico.svg`}
                description={getField(dictionary, 'card-two', language)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              sx={{ display: 'flex', justifyContent: 'center', padding: 0 }}
            >
              <SupportCard
                title={getField(dictionary, 'free-data-entry', language)}
                image={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/Service-amico.svg`}
                description={getField(dictionary, 'card-three', language)}
              />
            </Grid>
          </Grid>
        </Box>
      </Container >
    </>
  );
};

export default Support;
